import { useEffect, useRef } from 'react';
import { useProjectStore } from './useProjectStore';

export const ProjectInit = () => {
  const initRooms = useProjectStore((s) => s.initRooms);
  const startAutoSave = useProjectStore((s) => s.startAutoSave);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;
    initRooms();
  }, [initRooms]);

  useEffect(() => {
    const cleanup = startAutoSave();
    return cleanup;
  }, [startAutoSave]);

  return null;
};